import { Alert } from 'antd';
import React from 'react';
import styled from 'styled-components';
const StyledAlert = styled(Alert) `
  width: 100%;
`;
export const SubmitFeedback = (props) => props.show ? (React.createElement(StyledAlert, { type: props.type, message: props.children, className: props.className })) : null;
